import pricingValidation from "../../../../components/modals/add-new-application-modal/pricing-validation";
import config from "../../../../config";

/**
 * Calculates the total of sales percentages from form values
 * @param {Object} values - Form values containing sales percentages
 * @param {string[]} fields - Array of field names to sum
 * @returns {number} Total percentage
 */
export const calculateSalesTotal = (values, fields) => {
  return fields.reduce((total, field) => total + Number(values[field] || 0), 0);
};

/**
 * Validates if sales percentages total equals 100%
 * @param {Object} values - Form values containing sales percentages
 * @param {string[]} fields - Array of field names to validate
 * @returns {boolean} True if total equals 100%, false otherwise
 */
export const validateSalesPercentages = (values, fields) => {
  const total = calculateSalesTotal(values, fields);
  return total === 100;
};

/**
 * Formats currency value with 2 decimal places
 * @param {number} value - Number to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value) => {
  return Number(value || 0).toFixed(2);
};

/**
 * Validates if a number is within a reasonable range
 * @param {number} value - Value to validate
 * @param {number} min - Minimum allowed value
 * @param {number} max - Maximum allowed value
 * @returns {boolean} True if value is within range
 */
export const isWithinRange = (value, min, max) => {
  const num = Number(value);
  return !isNaN(num) && num >= min && num <= max;
};

/**
 * Returns the appropriate pricing validation object based on the pricing model
 * @param {string} pricingModel - The pricing model to get validation for
 * @param {string|null} organizationId - Optional organization ID for organization-specific validation
 * @returns {Object} The validation object for the specified pricing model
 */
export const getPricingValidation = (pricingModel, organizationId = null) => {
  if (pricingModel === "dual_pricing") {
    return getDualPricingValidation(organizationId);
  } else if (pricingModel === "surcharge") {
    return pricingValidation.pricingValidation.surcharge;
  } else if (pricingModel === "flat_rate") {
    return pricingValidation.pricingValidation.flat_rate;
  } else if (pricingModel === "tiered") {
    return pricingValidation.pricingValidation.tiered;
  } else if (pricingModel === "ic_plus") {
    return pricingValidation.pricingValidation.ic_plus;
  }

  return null;
};

/**
 * Returns the appropriate dual pricing validation object based on the organization ID
 * @param {string|null} organizationId - Optional organization ID for organization-specific validation
 * @returns {Object} The validation object for the specified organization ID
 */
export const getDualPricingValidation = (organizationId) => {
  if (organizationId == config.paymentcloud.PAYCHEX_ORG_ID) {
    return pricingValidation.pricingValidation.paychex_dual_pricing;
  } else {
    return pricingValidation.pricingValidation.dual_pricing;
  }
};
